<div #basicPanel
     class="search-condition">
  <div class="search-condition__contents">
    <ng-content select="[basic-condition]"></ng-content>
  </div>
  <div class="search-condition__btn">
    <button #btnDetail *ngIf="isDisplayDetailToggle" type="button" class="btn btn-default"
            [disabled]="disabledDetailToggle"
            (click)="onClickDetailToggle($event)"
            (keydown)="onKeyDown($event)">
      <span>{{detailToggleBtnText}}</span>
      <span class="caret">
      </span>
    </button>
    <div class="u-mg10t" *ngIf="isDisplaySubSearchButton">
      <button type="button" #basicSearchBtn
              class="btn btn-success w-80px"
              (click)="onSearch($event)"
              [disabled]="disabledSearchButton">
        <span>{{searchBtnText}}</span>
      </button>
    </div>
  </div>
</div>

<!-- 詳細条件パネルの背面を先に定義 -->
<div class="search-condition-detail-backdrop"
     [class.show]="closeBackdrop && detailConditionShown"
     (click)="onClickBackdrop($event)"
></div>

<!-- 詳細検索条件パネル -->
<div class="search-condition-detail"
     [class.show]="detailConditionShown"
     [style.max-width]="basicWidth"
     (transitionend)="onTransitionEnd($event)">
  <ng-container *ngIf="inTransition || detailConditionShown">
    <div class="search-condition-detail-title">{{detailPanelText}}</div>
    <div class="search-condition-detail-body">
      <div class="search-condition-detail-body-inner">
        <ng-content select="[detail-condition]"></ng-content>
      </div>
    </div>
    <div class="search-condition-detail-footer">
      <div class="search-condition-detail-footer-condition">
        <ng-content select="[detail-footer-condition]"></ng-content>
      </div>
      <div class="search-condition-detail-footer-btn">
        <button type="button" #btnClear
                class="btn btn-default"
                (click)="onClear($event)"
                [disabled]="!detailConditionShown">
          {{clearBtnText}}
        </button>
        <button type="button" #detailSearchBtn
                class="btn btn-success u-mg8l"
                (click)="onSearch($event)"
                [tooltip]="searchButtonTooltip"
                placement="bottom" container="body" triggers="pointerenter:pointerout"
                [disabled]="!detailConditionShown || disabledSearchButton">
          {{searchBtnText}}
        </button>
      </div>
    </div>
  </ng-container>
</div>



// WEBPACK FOOTER //
// ./src/app/feature/sns-send-message-modal/condition-panel/sns-send-message-condition-panel.component.html